import { useState } from "react";
import AccIcons from "@public/assets/icon/acc-icon.png";
import useAccordion from "@/components/common/Accordion";
import styled from "styled-components";
import {SIZES} from "@/components/constants";

const AccordionSection = ({ title, desc, list }) => {

    const accordionInfo = useAccordion(0);
    const [showAll, setShowAll] = useState(false);
    const visibleList = showAll ? list : list.slice(0, 5);

    return (
        <AccordionSectionWrap>

            <div className={"toggle-sec-title"}>
                <h2 dangerouslySetInnerHTML={{ __html: title }} />
                {desc && <p dangerouslySetInnerHTML={{ __html: desc }} />}
            </div>

            <div className={"toggle-info-area"}>
                <div className={"accordion-wrap"}>
                    {visibleList.map((item, idx) => {
                        const isOpen = accordionInfo.openIndex === idx;
                        return (
                            <div
                                key={item.id || idx}
                                className={`acc-item ${isOpen ? "is-open" : ""}`}
                            >
                                <div
                                    className={"acc-head"}
                                    onClick={() => accordionInfo.toggle(idx)}
                                >
                                    {`${idx + 1}. ${item.title}`}
                                    <span className={"acc-icon"}>
                                        <img src={AccIcons?.src} alt="" />
                                    </span>
                                </div>

                                <div
                                    className={"acc-body-outer"}
                                    style={
                                        accordionInfo.touchedRef.current
                                            ? {
                                                height: isOpen
                                                    ? `${accordionInfo.getOuterHeight(
                                                        accordionInfo.itemRefs.current[idx]
                                                    )}px`
                                                    : "0px",
                                            }
                                            : undefined
                                    }
                                >
                                    <div
                                        className={"acc-body"}
                                        ref={(el) => {
                                            accordionInfo.itemRefs.current[idx] = el;
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html: item.content,
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>

                {list.length > 5 && !showAll && (
                    <div
                        className={"more-btn"}
                        onClick={() => setShowAll(true)}
                    >
                        더보기
                    </div>
                )}

            </div>
        </AccordionSectionWrap>
    );
};
const AccordionSectionWrap = styled.div`

    row-gap: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;
    .toggle-sec-title{
        column-gap: 16px;

        flex-direction: column;
        display: flex;
        h2{
            font-weight: 700;
            font-size: 32px;
            color: #07903a;
        }
    }

    .toggle-info-area {
        display: flex;
        width: 100%;
        flex-direction: column;
        row-gap: 10px;
        max-width: 840px;
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;

        .acc-item {
            & + .acc-item {
                margin-top: 12px;
            }

            .acc-head {
                padding: 16px 24px;
                border-radius: 16px;
                border: 1px solid #dfdfe1;
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 5px;
                cursor: pointer;
                background: #fff;
            }

            .acc-icon {
                width: 24px;
                flex-shrink: 0;
                transition: transform 220ms ease;
            }

            &.is-open .acc-icon {
                transform: rotate(180deg);
            }

            .acc-body-outer {
                height: 0;
                overflow: hidden;
                transition: height 260ms cubic-bezier(0.4, 0, 0.2, 1);
            }

            /* 초기 열림 전용 */
            &.is-open .acc-body-outer {
                height: auto;
            }

            .acc-body {
                padding: 12px 28px;
                margin-top: 12px;
                background: #f1f3f7;
                border-radius: 16px;
            }
        }
        .more-btn{
            font-weight: 700;
            font-size: 20px;
            color: #828282;
            padding: 16px 24px;
            border-radius: 16px;
            border: 1px solid #dfdfe1;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            background: #fff;
        }
    }

    @media (min-width: ${SIZES.MOBILE_L}) {
        flex-direction: row;

        .toggle-info-area{
            row-gap: 24px;
        }
    }
    @media (min-width: ${SIZES.TABLET_L}) {
        .toggle-info-area{
            
            .acc-item{
                & + .acc-item {
                    margin-top: 24px;
                }
                .acc-body{
                    margin-top: 24px;
                }
            }
        }
    }
`
export default AccordionSection;